import type { PersonalizedTaskStatus, PersonalizedTasksStatus } from '@change-corgi/middle-end-gql-schema';

export const PERSONALIZED_TASK_STATUSES = {
	ACTIVE: 'ACTIVE',
	COMPLETED: 'COMPLETED',
} as const satisfies Record<string, PersonalizedTaskStatus>;

export const PERSONALIZED_TASKS_GENERATION_STATUSES = {
	PENDING: 'PENDING',
	IN_PROGRESS: 'IN_PROGRESS',
	COMPLETED: 'COMPLETED',
	FAILED: 'FAILED',
} as const satisfies Record<string, PersonalizedTasksStatus>;

export const FAST_POLLING_INTERVAL = 3000;
export const SLOW_POLLING_INTERVAL = 5000;
export const FAST_POLL_MAX_COUNT = 5;
